"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.grey = void 0;
var chroma = require("chroma-js");
var NUM_COLORS = 9;
var BASE = chroma("rgb(8,8,18)");
var BRIGHT_AMOUNT = 1;
exports.grey = {};
for (var i = 1; i <= NUM_COLORS; i++) {
    var amount = (i / NUM_COLORS) * BRIGHT_AMOUNT;
    exports.grey[i * 100] = BASE.brighten(amount).hex();
}
